import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";

export const commercialSegmentListAtom = atom<SelectElementModelFE[]>({
    key: "commercialSegmentListAtom",
    default: []
});